(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('Test', Test);

    Test.$inject = ['$resource'];

    function Test ($resource) {
        var resourceUrl =  'api/tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
